module.exports = __webpack_public_path__ + "img/MdNewsTitle.f1d41f24.png";